import { buildFormulaMatrix } from './formulaMatrix.js';

export function matrix(formula, coefficients) {
  const result = buildFormulaMatrix({ formula, coefficients });
  return result;
}



/*
matrix("bookformula14", [
    2.11,
    1.550,
    2.08
]);
*/